aaa
<app-game></app-game>